var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkInActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.11401 14.0627C3.28867 14.2367 3.52001 14.3334 3.76734 14.3334C3.92401 14.3334 4.08001 14.2927 4.21867 14.2154L8.01669 12.0867L11.7787 14.2107C11.9934 14.332 12.242 14.3634 12.48 14.296C12.7174 14.23 12.9147 14.0754 13.0354 13.8614C13.1134 13.7227 13.1547 13.566 13.1547 13.408L13.1514 4.39069C13.1514 2.63402 12.0214 1.66669 9.97136 1.66669H6.02667C4.00467 1.66669 2.84534 2.61802 2.84534 4.27669V13.4107C2.84467 13.6567 2.94001 13.888 3.11401 14.0627Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99951 9.04058C7.72351 9.04058 7.49951 8.81658 7.49951 8.54058V7.47991H6.43884C6.16284 7.47991 5.93884 7.25591 5.93884 6.97991C5.93884 6.70391 6.16284 6.47992 6.43884 6.47992H7.49951V5.41925C7.49951 5.14325 7.72351 4.91925 7.99951 4.91925C8.27551 4.91925 8.49951 5.14325 8.49951 5.41925V6.47992H9.56018C9.83618 6.47992 10.0602 6.70391 10.0602 6.97991C10.0602 7.25591 9.83618 7.47991 9.56018 7.47991H8.49951V8.54058C8.49951 8.81658 8.27551 9.04058 7.99951 9.04058Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkInActive);
export default __webpack_public_path__ + "static/media/bookmarkInActive.1159ee19.svg";
export { ForwardRef as ReactComponent };